import ContentModel from '../models/ContentModel';
import { stitchDefaults } from './defaults';

const { env, ...otherDefaults } = stitchDefaults;
export default {
    ...otherDefaults,
    model: ContentModel,
    pathTemplate: `bdfed/gameday-content/?locale={locale:en}&gamePk={gamePk}`,
    env: {
        ...env,
        qa: {
            ...env.qa,
            pathTemplate: `bdfed/gameday-content/?locale={locale:en}&gamePk={gamePk}&stitch_env=qa`
        }
    }
};
